import React from "react";
import java from "./images/icons8-java (1).svg"
import c from "./images/icons8-c-50.png"
import cplusplus from "./images/icons8-c-50 (1).png"
import csharp from "./images/icons8-c-sharp-logo-50.png"
import python from "./images/icons8-python-50.png"
import js from "./images/icons8-javascript-50.png"
import react from "./images/icons8-react-js.svg"
import node from "./images/icons8-node-js.svg"
import ex from "./images/icons8-express-js.svg"
import mongo from "./images/mongodb (1).svg"
import sqllogo from "./images/sql-file-icon.svg"

export default function Skills(){
    return (
        <div className="skill-container">
            <h1 className="skill-title">Technical Skillset</h1>
            <div className="skills-subcontainer">
                <div className="skills">
                    <h1>Languages</h1>
                    <div className="skill-set">
                        <img src={java} alt=""  />
                        <p>Java</p>,
                        <img src={js} alt=""  />
                        <p>Javascript</p>,
                        <img src={c} alt=""  />
                        <p>C</p>,
                        <img src={cplusplus} alt=""  />
                        <p>C++</p>,
                        <img src={csharp} alt=""  />
                        <p>C#</p>, 
                        <img src={python} alt=""  />
                        <p>Python</p>
                    </div>
                    <h1>Framework</h1>
                    <div className="skill-set">
                        <img src={react} alt=""  />
                        <p>React Js</p>,
                        <img src={node} alt=""  />
                        <p>Node Js</p>,
                        <img src={ex} alt=""  />
                        <p>Express Js</p>
                    </div>
                    <h1>Database</h1>
                    <div className="skill-set">
                        <img src={sqllogo} alt=""  style={{filter:"invert(1)"}} />
                        <p>SQL</p>,
                        <img src={mongo} alt=""  style={{filter:"invert(1)"}}/>
                        <p>Mongo DB</p>
                    </div>
                </div>
            </div>
        </div>
    )
}